export default __webpack_public_path__ + "static/media/07.25e8b860.jpg";